module.exports = __webpack_public_path__ + "img/Experiment.68e85845.jpg";